import { render, staticRenderFns } from "./KImage.vue?vue&type=template&id=49db36b8&"
import script from "./KImage.vue?vue&type=script&lang=js&"
export * from "./KImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports